import type { SxProps, Theme } from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import type { EntityName } from '../../auth/Security';
import ResponsiveActions from '../../components/ResponsiveActions';
import { useDataListActions } from './hooks/useDataListActions';
import type { DataListActionHandlers, DataListCellActionHandlers, DataListCustomRowAction } from './types';

type DataListRowActionsProps = {
    item: Record<string, unknown>;
    feature: string;
    /**
     * Optional only to support callers that still rely on the legacy permission fallback.
     * Make required once those callers forward it and the missing-entity fallback is removed.
     */
    entity?: EntityName;
    actionHandlers?: DataListActionHandlers | DataListCellActionHandlers;
    customRowActions?: DataListCustomRowAction[];
    isActivated?: boolean;
    containerSx?: SxProps<Theme>;
};

export default function DataListRowActions({
    item,
    feature,
    entity,
    actionHandlers = {},
    customRowActions = [],
    isActivated = false,
    containerSx = { position: 'absolute', right: '5px' }
}: DataListRowActionsProps) {
    const actions = useDataListActions({
        item,
        feature,
        entity,
        customRowActions,
        onEdit: actionHandlers.onEdit,
        onShare: actionHandlers.onShare,
        onDelete: actionHandlers.onDelete,
        onAttachments: actionHandlers.onAttachments,
        onNotes: actionHandlers.onNotes,
        onActivateOrInactivateHandle: actionHandlers.onActivateOrInactivateHandle,
        onCustomAttribute: actionHandlers.onCustomAttribute,
        onTagHandle: actionHandlers.onTagHandle
    });

    if (isEmpty(actionHandlers) && isEmpty(customRowActions)) {
        return null;
    }

    if (!actions.length) {
        return null;
    }

    return (
        <ResponsiveActions
            showBorder
            isActivated={isActivated}
            securedActions={actions}
            containerSx={containerSx}
        />
    );
}
